export { default as ListadoArticulosVenta } from "./Listado";
